<mat-sidenav-container class="app-sidenav-container">
  @if (this.ShowAppChrome) {
    <mat-sidenav #sidenav mode="side" opened class="{{AppSideNavClasses}}" role="navigation"
      id="navigation-menu" (drop)="this.blockDrop($event)" (dragover)="this.blockDrop($event)">
      <div mat-subheader
        attr.aria-label="{{menuTitle()}}"
        (click)="toggleMenu()"
        tabindex="0"
        (keyup.enter)="toggleMenu()"
        class="menu-header {{siteWorkflowState}}">
        @if (opened) {
          <span>
            {{ menuTitle() }} @if (showStatusInTitle()) {
            <span>({{uppercaseSiteWorkflowState}})</span>
          }
        </span>
      }
      @if (opened) {
        <mat-icon class="menu-close" title="Click to collapse this Menu bar">
          arrow_left
        </mat-icon>
      }
      @if (!opened) {
        <mat-icon
          attr.aria-label="{{menuTitle()}} (Click to expand)"
          class="menu-open"
          title="{{menuTitle()}} (Click to expand)">
          menu
        </mat-icon>
      }
    </div>
    <mat-divider></mat-divider>
    <mat-nav-list>
        @for (item of menu.navItems; track item) {
        <!-- See https://community-dc.max.gov/x/pYY3og for background on claims and how they're used to protect access to the application's pages/routes -->
        @if (item?.text != 'Go Back' && userClaims?.has(item['claim'])) {
        <mat-list-item [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                       (keyup.enter)="navigateTo(item.route)" title="{{item.text}}">
            @if (this.HasMatIcon(item)) {
            <mat-icon mat-list-icon class="nav-icon">{{item.icon}}</mat-icon>
            }
            @if (this.HasSvgIcon(item)) {
            <mat-icon svgIcon="{{item.icon}}" class="nav-icon-svg" mat-list-icon></mat-icon>
            }
            <!--VNEXT-1430: KLW - Styling changes to account for upgrading Material from 13 to 14 to 15 -->
            @if (opened) {
            <div>{{item.text}}</div>
            }
        </mat-list-item>
        }
        @if (item.text == 'Go Back') {
        <mat-list-item (click)="navigateTo(item.route, true)"
                       (keyup.enter)="navigateTo(item.route, true)" title="{{item.text}}" tabindex="0">
            @if (this.HasMatIcon(item)) {
            <mat-icon mat-list-icon class="nav-icon">{{item.icon}}</mat-icon>
            }
            @if (this.HasSvgIcon(item)) {
            <mat-icon svgIcon="{{item.icon}}" mat-list-icon></mat-icon>
            }
            <!--VNEXT-1430: KLW - Styling changes to account for upgrading Material from 13 to 14 to 15 -->
            @if (opened) {
            <div>{{item.text}}</div>
            }
        </mat-list-item>
        }
        }
    </mat-nav-list>
  </mat-sidenav>
}
<mat-sidenav-content [ngClass]="this.ShowAppChrome ? AppSideNavContentClasses : 'app-sidenav-content-no-chrome'"
  role="main" id="main-content" tabindex="0">
  <router-outlet></router-outlet>
</mat-sidenav-content>
</mat-sidenav-container>
